module.exports = __webpack_public_path__ + "resources/incoming-call-aaaf0cb6c27e80d151d140aa8f7fda76.svg";